import { ResponseContext } from "../../../@api";

import { translationKeys } from "../../models/app-translation-keys";
import { IMiddelware } from "../../models/interfaces/middelware.interface";
import { BudgetStore, GlobalErrorsStore } from "../../stores";

export class PaymentResponseHandlingMiddleware implements IMiddelware {
  public readonly handledHttpStatusCodes = [402];

  constructor(
    private readonly budgetStore: BudgetStore,
    private readonly globalErrorsStore: GlobalErrorsStore,
  ) {}

  public async post(context: ResponseContext): Promise<void> {
    if (this.handledHttpStatusCodes.includes(context.response.status)) {
      this.setError(context);
    } else {
      this.resetError();
    }
  }

  public resetError() {
    this.budgetStore.setBudgetDisabled(false);
    this.budgetStore.errorCode = undefined;
  }

  public setError(context: ResponseContext) {
    this.budgetStore.setBudgetDisabled(true);
    this.budgetStore.errorCode = context.response.status;
    this.globalErrorsStore.addErrorIfNotExists(translationKeys.globalErrors.budgetErrors.default);
  }
}
